import { useCallback } from "react";
import { useState, useEffect } from "react";

function PlotSummary({ getSummary, pngDataUrl, Dyn }) {
    const [summaryText, setSummaryText] = useState("");
    const [showCopied, setShowCopied] = useState(false);

    useEffect(() => {
        setSummaryText(getSummary ? getSummary() : "");
    }, [pngDataUrl, getSummary]);

    const copyToClibboard = useCallback(() => {
        if (window.ClipboardItem) {
            navigator.clipboard
                .writeText(summaryText)
                .then(() => {
                    setShowCopied(true);
                    setTimeout(() => {
                        setShowCopied(false);
                    }, 2000);
                })
                .catch((err) => {
                    console.log("error", err);
                    alert("Unable to copy.")
                });
        } else {
            console.log("Browser doesn't support copy image feature.");
            alert("Unable to copy.")
        }
    }, [summaryText]);

    return (
        <div className="tde-border-top tde-p-4">
            <div className="tde-mb-2 tde-font-bold">
                <span>{Dyn.loc("Plot Summary (Alt Text)")}</span>
                <button
                    className={
                        "tde-btn tde-ml-3" + (showCopied ? " tde-active" : "")
                    }
                    onClick={copyToClibboard}
                >
                    <i className="tde-i tde-i-copy"></i>{" "}
                    {Dyn.loc(showCopied ? "Copied" : "Copy")}
                </button>
            </div>
            <div className="tde-summary-text">
                {summaryText || Dyn.loc("No summary available")}
            </div>
        </div>
    );
}

export default PlotSummary;
